import { RegisterState } from './types'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const state: RegisterState = {
  emailError: false,
  provider: '',
  displayName: '',
  email: '',
  profilePicURL: '',
  providers: [],
  bindingErrorCount: 0
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
